export const OBJECT = "object";
export const ACCIONES = "acciones";
export const CORREOS = "correos";
export const CORREO = "correo";
export const RESPONSABLES = "responsables";
export const GEOCERCAS = "geocercas";
export const LISTA_CORREOS = "listaCorreos";
export const COLOR = "color";
export const COLOR_A_TIEMPO = "coloratiempo";
export const COLOR_RETRASO = "colorretraso";
export const UBICACION_GPS = "ubicaciongps";
export const CHECK = "check";
export const URL = "url";


export const STRING_DEFAULT_OPCION_RESPUESTA_COLOR = "#d43224";

export const STRING_SIDEBAR_EXPANDED = "SIDEBAR_EXPANDED";
export const STRING_TRUE = "true";
export const STRING_FALSE = "false";

export const STRING_ID_EMPRESA_CHECKLIST = "idEmpresaChecklist";
export const STRING_ACCESS_TOKEN_CHECKLIST = "accessTokenChecklist";
export const STRING_TIPO_USUARIO_CHECKLIST = "tipoUsuarioChecklist";
export const STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST = "idSubTipoUsuarioWebChecklist";

export const STRING_DEFAULT_URL_IMAGEN_PREGUNTA_CHECKLIST = "";

export const STRING_LANGUAGE = "language";

export const STRING_COLOR_PRIMARIO = "colorPrimarioChecklist";

export const STRING_VERSION = "2.2.9";